import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import { CustomerActionTypes } from '../actions/customer.actions';
var initialState = {
    loading: [],
    isUploadingCustomersBatchFile: null,
    customer: null,
    customerStatus: null,
    record: null,
    customers: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    currentCrp: null,
    crps: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    crpsNoPrimary: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    documents: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    customersBatchUploads: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    comments: null,
    defaultNotifiedUsers: null,
    users: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    entitytypes: [],
    ownershipLayers: [],
    countries: [],
    ssoc: [],
    ssic: [],
    idTypes: [],
    sourceOfFunds: [],
    titles: [],
    onboardingModes: [],
    paymentModes: [],
    productServiceComplexities: [],
    customerComments: null,
    error: []
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CustomerActionTypes.CREATE_DRAFT_CUSTOMER: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER]) });
        }
        case CustomerActionTypes.CREATE_AND_RA_CUSTOMER: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER]) });
        }
        case CustomerActionTypes.CREATE_AND_CRP_CUSTOMER: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER]) });
        }
        case CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER_SUCCESS: {
            return tslib_1.__assign({}, state, { error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER;
                }), loading: clearLoading(state, CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER) });
        }
        case CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER,
                        detail: action.payload
                    }]), loading: clearLoading(state, CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER) });
        }
        case CustomerActionTypes.CREATE_AND_ADD_CRP: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([CustomerActionTypes.CREATE_OR_UPDATE_CRP]) });
        }
        case CustomerActionTypes.CREATE_AND_RA_CRP: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([CustomerActionTypes.CREATE_OR_UPDATE_CRP]) });
        }
        case CustomerActionTypes.UPDATE_AND_RA_CRP: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([CustomerActionTypes.CREATE_OR_UPDATE_CRP]) });
        }
        case CustomerActionTypes.UPDATE_AND_ADD_CRP: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([CustomerActionTypes.CREATE_OR_UPDATE_CRP]) });
        }
        case CustomerActionTypes.CREATE_OR_UPDATE_CRP: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.CREATE_OR_UPDATE_CRP_SUCCESS: {
            return tslib_1.__assign({}, state, { error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.CREATE_OR_UPDATE_CRP;
                }), loading: clearLoading(state, CustomerActionTypes.CREATE_OR_UPDATE_CRP) });
        }
        case CustomerActionTypes.CREATE_OR_UPDATE_CRP_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.CREATE_OR_UPDATE_CRP,
                        detail: action.payload
                    }]), loading: clearLoading(state, CustomerActionTypes.CREATE_OR_UPDATE_CRP) });
        }
        case CustomerActionTypes.GET_CUSTOMER: {
            return tslib_1.__assign({}, state, { loading: action.payload.quietUpdate ? state.loading : state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.GET_CUSTOMER_SUCCESS: {
            return tslib_1.__assign({}, state, { customer: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_CUSTOMER;
                }), loading: clearLoading(state, CustomerActionTypes.GET_CUSTOMER) });
        }
        case CustomerActionTypes.GET_CUSTOMER_FAILURE: {
            return tslib_1.__assign({}, state, { customer: action.payload, error: state.error.concat([{
                        action: CustomerActionTypes.GET_CUSTOMER,
                        detail: action.payload
                    }]), loading: clearLoading(state, CustomerActionTypes.GET_CUSTOMER) });
        }
        case CustomerActionTypes.GET_CUSTOMER_STATUS: {
            return tslib_1.__assign({}, state);
        }
        case CustomerActionTypes.GET_CUSTOMER_STATUS_SUCCESS: {
            return tslib_1.__assign({}, state, { customerStatus: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_CUSTOMER_STATUS;
                }) });
        }
        case CustomerActionTypes.GET_CUSTOMER_STATUS_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.GET_CUSTOMER_STATUS,
                        detail: action.payload
                    }]) });
        }
        case CustomerActionTypes.RESET_CUSTOMER_OVERVIEW: {
            return tslib_1.__assign({}, state, { customer: action.payload, currentCrp: null, crps: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, crpsNoPrimary: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                } });
        }
        case CustomerActionTypes.GET_CUSTOMERS: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.GET_CUSTOMERS_SUCCESS: {
            return tslib_1.__assign({}, state, { customers: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_CUSTOMERS;
                }), loading: clearLoading(state, CustomerActionTypes.GET_CUSTOMERS) });
        }
        case CustomerActionTypes.GET_CUSTOMERS_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.GET_CUSTOMERS,
                        detail: action.payload
                    }]), loading: clearLoading(state, CustomerActionTypes.GET_CUSTOMERS) });
        }
        case CustomerActionTypes.GET_CRP: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.GET_CRP_SUCCESS: {
            return tslib_1.__assign({}, state, { currentCrp: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_CRP;
                }), loading: clearLoading(state, CustomerActionTypes.GET_CRP) });
        }
        case CustomerActionTypes.GET_CRP_FAILURE: {
            return tslib_1.__assign({}, state, { currentCrp: null, error: state.error.concat([{
                        action: CustomerActionTypes.GET_CRP,
                        detail: action.payload
                    }]), loading: clearLoading(state, CustomerActionTypes.GET_CRP) });
        }
        case CustomerActionTypes.UPDATE_CRP_SCREENING: {
            var index = state.crps.results.findIndex(function (crp) { return crp.id === action.payload.crp; });
            return tslib_1.__assign({}, state, { currentCrp: tslib_1.__assign({}, state.currentCrp, { latestScreeningConclusion: action.payload }), crps: tslib_1.__assign({}, state.crps, { results: (index > -1) ? state.crps.results.slice(0, index).concat([
                        Object.assign({}, state.crps.results[index], tslib_1.__assign({}, state.crps.results[index], { latestScreeningConclusion: action.payload }))
                    ], state.crps.results.slice(index + 1)) : state.crps.results }) });
        }
        case CustomerActionTypes.GET_CRPS_NO_PRIMARY:
        case CustomerActionTypes.GET_CRPS: {
            return tslib_1.__assign({}, state, { loading: action.payload.quietUpdate ? state.loading : state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.GET_CRPS_SUCCESS: {
            return tslib_1.__assign({}, state, { crps: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_CRPS;
                }), loading: clearLoading(state, CustomerActionTypes.GET_CRPS) });
        }
        case CustomerActionTypes.GET_CRPS_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.GET_CRPS,
                        detail: action.payload
                    }]), loading: clearLoading(state, CustomerActionTypes.GET_CRPS) });
        }
        case CustomerActionTypes.GET_CRPS_NO_PRIMARY_SUCCESS: {
            return tslib_1.__assign({}, state, { crpsNoPrimary: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_CRPS_NO_PRIMARY;
                }), loading: clearLoading(state, CustomerActionTypes.GET_CRPS_NO_PRIMARY) });
        }
        case CustomerActionTypes.GET_CRPS_NO_PRIMARY_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.GET_CRPS_NO_PRIMARY,
                        detail: action.payload
                    }]), loading: clearLoading(state, CustomerActionTypes.GET_CRPS_NO_PRIMARY) });
        }
        case CustomerActionTypes.GET_CUSTOMER_DOCUMENTS: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.GET_CUSTOMER_DOCUMENTS_SUCCESS: {
            return tslib_1.__assign({}, state, { documents: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_CUSTOMER_DOCUMENTS;
                }), loading: clearLoading(state, CustomerActionTypes.GET_CUSTOMER_DOCUMENTS) });
        }
        case CustomerActionTypes.GET_CUSTOMER_DOCUMENTS_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.GET_CUSTOMER_DOCUMENTS,
                        detail: action.payload
                    }]), documents: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, loading: clearLoading(state, CustomerActionTypes.GET_CUSTOMER_DOCUMENTS) });
        }
        case CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST_SUCCESS: {
            return tslib_1.__assign({}, state, { customersBatchUploads: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST;
                }), loading: clearLoading(state, CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST) });
        }
        case CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST,
                        detail: action.payload
                    }]), customersBatchUploads: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, loading: clearLoading(state, CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST) });
        }
        case CustomerActionTypes.UPLOAD_CUSTOMERS_BATCH_FILE: {
            return tslib_1.__assign({}, state, { isUploadingCustomersBatchFile: true });
        }
        case CustomerActionTypes.UPLOAD_CUSTOMERS_BATCH_FILE_SUCCESS: {
            return tslib_1.__assign({}, state, { isUploadingCustomersBatchFile: false, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.UPLOAD_CUSTOMERS_BATCH_FILE;
                }) });
        }
        case CustomerActionTypes.UPLOAD_CUSTOMERS_BATCH_FILE_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.UPLOAD_CUSTOMERS_BATCH_FILE,
                        detail: action.payload
                    }]), isUploadingCustomersBatchFile: false });
        }
        case CustomerActionTypes.CLEAR_GET_CUSTOMERS_BATCH_UPLOADS_LIST: {
            return tslib_1.__assign({}, state, { customersBatchUploads: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, loading: clearLoading(state, CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST) });
        }
        case CustomerActionTypes.GET_USERS: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.GET_USERS_SUCCESS: {
            return tslib_1.__assign({}, state, { users: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_USERS;
                }), loading: clearLoading(state, CustomerActionTypes.GET_USERS) });
        }
        case CustomerActionTypes.GET_USERS_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.GET_USERS,
                        detail: action.payload
                    }]), loading: clearLoading(state, CustomerActionTypes.GET_USERS) });
        }
        case CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS), defaultNotifiedUsers: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS;
                }) });
        }
        case CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS), error: state.error.concat([{
                        action: CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS,
                        detail: action.payload
                    }]) });
        }
        case CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS), defaultNotifiedUsers: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS;
                }) });
        }
        case CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS), error: state.error.concat([{
                        action: CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS,
                        detail: action.payload
                    }]) });
        }
        case CustomerActionTypes.PATCH_CUSTOMER: {
            return tslib_1.__assign({}, state, { loading: action.payload.quietUpdate ? state.loading : state.loading.concat([action.type]) });
        }
        case CustomerActionTypes.PATCH_CUSTOMER_SUCCESS: {
            return tslib_1.__assign({}, state, { customer: action.payload, error: state.error.filter(function (item) {
                    return item.action !== CustomerActionTypes.PATCH_CUSTOMER;
                }), loading: clearLoading(state, CustomerActionTypes.PATCH_CUSTOMER) });
        }
        case CustomerActionTypes.PATCH_CUSTOMER_FAILURE: {
            return tslib_1.__assign({}, state, { error: state.error.concat([{
                        action: CustomerActionTypes.PATCH_CUSTOMER,
                        detail: action.payload
                    }]), loading: clearLoading(state, CustomerActionTypes.PATCH_CUSTOMER) });
        }
        case CustomerActionTypes.CLEAR_ERRORS: {
            return tslib_1.__assign({}, state, { error: [] });
        }
        default: {
            return state;
        }
    }
}
var customer = function (state) { return state.customer; };
var ɵ0 = customer;
var ɵ1 = function (state) { return state.error; }, ɵ2 = function (state) { return state.loading; }, ɵ3 = function (state) { return state.isUploadingCustomersBatchFile; }, ɵ4 = function (state) { return state.customer; }, ɵ5 = function (state) { return state.customerStatus; }, ɵ6 = function (state) { return state.customers; }, ɵ7 = function (state) { return state.currentCrp; }, ɵ8 = function (state) { return state.crps; }, ɵ9 = function (state) { return state.crpsNoPrimary; }, ɵ10 = function (state) { return state.documents; }, ɵ11 = function (state) { return state.customersBatchUploads; }, ɵ12 = function (state) { return state.comments; }, ɵ13 = function (state) { return state.users; }, ɵ14 = function (state) { return state.defaultNotifiedUsers; };
export var Selectors = {
    getErrors: createSelector(customer, ɵ1),
    getLoading: createSelector(customer, ɵ2),
    isUploadingCustomersBatchFile: createSelector(customer, ɵ3),
    getCustomer: createSelector(customer, ɵ4),
    getCustomerStatus: createSelector(customer, ɵ5),
    getCustomers: createSelector(customer, ɵ6),
    getCurrentCrp: createSelector(customer, ɵ7),
    getCrps: createSelector(customer, ɵ8),
    getCrpsNoPrimary: createSelector(customer, ɵ9),
    getDocuments: createSelector(customer, ɵ10),
    getCustomersBatchUploads: createSelector(customer, ɵ11),
    getComments: createSelector(customer, ɵ12),
    getUsers: createSelector(customer, ɵ13),
    getDefaultNotifiedUsers: createSelector(customer, ɵ14)
};
function clearLoading(authState, action) {
    return authState.loading.filter(function (loadingMarker) { return loadingMarker !== action; });
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14 };
